import React, { useEffect, useState } from 'react';
import styles from './ActionRow.module.scss';
import { Button, message, Tooltip } from 'antd';
import useCallRecord from '../../../../../CallHistory/queries/useCallRecord';
import { recordActionTypes } from '../../../../../CallHistory/components/CallList/constants';
import { createDownloadLink } from '../../../../../CallHistory/components/CallList/utils';
import { useDispatch } from 'react-redux';
import {
  setCurrentCallInfo,
  setCurrentRecordUrl,
  setListenModalVisible,
} from '../../../../../CallHistory/store/callHistoryActions';

const ActionRow = ({ call }) => {
  const dispatch = useDispatch();

  const [sendRecordRequest, setSendRecordRequest] = useState(false);
  const [recordActionType, setRecordActionType] = useState('');
  const [recordLink, setRecordLink] = useState(null);

  const { data: callRecord, isFetching: isCallRecordFetching } = useCallRecord(
    call.uniqueId,
    {
      enabled: sendRecordRequest,
      staleTime: Infinity,
      select: (data) => {
        if (data && data !== 'Error') {
          const recordBuffer = Buffer.from(data, 'base64');
          const url = URL.createObjectURL(new Blob([recordBuffer]));
          return url;
        }

        return data;
      },
    }
  );

  const handleDownloadRecordBtnClick = (e) => {
    e.stopPropagation();

    if (!sendRecordRequest) {
      setSendRecordRequest(true);
    }
    setRecordActionType(recordActionTypes.download);
  };

  const handlePlayRecordClick = (e) => {
    e.stopPropagation();

    if (!sendRecordRequest) {
      setSendRecordRequest(true);
    }
    setRecordActionType(recordActionTypes.play);
  };

  useEffect(() => {
    if (callRecord && callRecord !== 'Error') {
      switch (recordActionType) {
        case recordActionTypes.download:
          recordLink
            ? recordLink.click()
            : setRecordLink(createDownloadLink(callRecord, call));
          setRecordActionType('');
          break;

        case recordActionTypes.play:
          dispatch(setListenModalVisible(true));
          dispatch(setCurrentRecordUrl(callRecord));
          dispatch(setCurrentCallInfo(call));
          setRecordActionType('');
          break;

        default:
          break;
      }
    } else {
      recordActionType && !isCallRecordFetching && message.info('Записи нет');
    }
  }, [
    dispatch,
    callRecord,
    recordActionType,
    recordLink,
    call,
    isCallRecordFetching,
  ]);

  return (
    <div className={styles.flexRow}>
      <Tooltip
        title="Прослушать"
        getPopupContainer={(trigger) => trigger.parentNode}
      >
        <Button
          shape="circle"
          className={styles.recordBtn}
          icon={
            isCallRecordFetching && recordActionType === recordActionTypes.play
              ? 'loading'
              : 'play-circle'
          }
          onClick={handlePlayRecordClick}
        />
      </Tooltip>
      <Tooltip
        title="Скачать"
        getPopupContainer={(trigger) => trigger.parentNode}
      >
        <Button
          shape="circle"
          icon={
            isCallRecordFetching &&
            recordActionType === recordActionTypes.download
              ? 'loading'
              : 'download'
          }
          onClick={handleDownloadRecordBtnClick}
          className={styles.recordBtn}
        />
      </Tooltip>
    </div>
  );
};

export default ActionRow;
